/* eslint-disable quote-props */
import { Box, Button, Typography } from "@mui/material";
import React, { ReactNode, useCallback } from "react";
import { useVetCoveRedirect } from "../../../../../hooks/useVetCoveRedirect";

interface NoContentProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string | ReactNode;
  size?: "small" | "medium";
  buttonText?: string;
  buttonUrl?: string;
  buttonWidth?: string;
  customButton?: ReactNode;
}

const NoContent = ({
  imageSrc,
  imageAlt,
  title,
  description,
  size = "medium",
  buttonText,
  buttonUrl,
  buttonWidth = "312px",
  customButton,
}: NoContentProps) => {
  const imageSize = size === "small" ? 110 : 220;
  const { handleVetCoveLink } = useVetCoveRedirect();

  const handleClick = useCallback(() => {
    if (buttonUrl) {
      handleVetCoveLink(buttonUrl);
    }
  }, [buttonUrl, handleVetCoveLink]);

  return (
    <Box className="flex flex-col items-center py-6 w-full" sx={{ gap: size === "small" ? 2 : 0 }}>
      <img src={imageSrc} alt={imageAlt} width={imageSize} height={imageSize} />
      <Box className="flex flex-col items-center text-center w-full pt-4">
        <Typography fontSize={24} fontWeight={600}>
          {title}
        </Typography>
        <Typography fontSize={14} marginTop={1} marginBottom={3}>
          {description}
        </Typography>
      </Box>
      {buttonText && buttonUrl && !customButton && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          sx={{
            width: buttonWidth,
            fontSize: "16px",
            fontWeight: 600,
            paddingX: "40px",
          }}
        >
          {buttonText}
        </Button>
      )}
      {customButton}
    </Box>
  );
};

export default NoContent;
